export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdź adres"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź adres"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykonaj sprawdzenie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niskie ryzyko"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Średnie ryzyko"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysokie ryzyko"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie ma na czarnej liście"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdź inny adres"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pobierz PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wstecz"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz dostawcę"])}
}